import { GetProductDetailsQuery } from '@/app/[lang]/(full)/products/[itemId]/getProductDetails.generated'
import { Specification } from '@/app/api/types/redpim.types'
import ToggleUnit from '@/components/ToggleUnit/ToggleUnit'
import { redpimToCorpoLocale } from '@/lib/locale.utils'
import { SpecCategories } from '@/lib/specifications/SpecCategories'

type ProductDetailsTechnicalProps = {
	lang: string
	fragment: GetProductDetailsQuery
	specifications: Specification[]
}

export default function ProductDetailsTechnical({
	lang,
	fragment,
	specifications,
}: ProductDetailsTechnicalProps) {
	const redpimLocale = redpimToCorpoLocale(lang as string)

	const categories: Record<string, Specification[]> = {}

	Object.entries(SpecCategories)
		.sort((a, b) => a[1].order - b[1].order)
		.forEach(([category, details]) => {
			categories[category] = []
			specifications.forEach((spec) => {
				if (details.specifications.includes(spec.attributeId)) {
					categories[category].push(spec)
				}
			})
			categories[category].sort((a, b) =>
				a.attributeId.localeCompare(b.attributeId),
			)
		})

	const hasTechnicalData = Object.values(categories).some(
		(specs) => specs.length > 0,
	)

	return (
		<>
			{hasTechnicalData ? (
				<>
					<div
						id={
							'spy_' +
							fragment.translations.technicalDescriptionTitle.replaceAll(
								' ',
								'_',
							)
						}
						className="h4 flex justify-between items-center w-full"
					>
						<div>{fragment.translations.technicalDescriptionTitle}</div>
						<div>
							<ToggleUnit />
						</div>
					</div>
					{Object.entries(categories)
						.filter(([, specs]) => specs.length > 0)
						.map(([category, specs]) => (
							<div key={category}>
								<h5 className="h5 my-4">{category}</h5>
								<ul className="w-full p-4 py-2 border border-gray-100 rounded-2xl bg-white">
									{specs.map((spec) => (
										<li
											className="flex justify-between px-2 py-3 border-b last:border-b-0 border-gray-100 gap-4"
											key={spec.attributeId}
										>
											{spec.value && (
												<>
													<p className="font-medium">
														{spec.nameIntl[redpimLocale]}
													</p>
													<p>{`${spec.value} ${spec.unit}`}</p>
												</>
											)}
										</li>
									))}
								</ul>
							</div>
						))}
				</>
			) : (
				<div className="h4 flex justify-between items-center w-full">
					{fragment.translations.noTechnicalData}
				</div>
			)}
		</>
	)
}
